import { render, staticRenderFns } from "./copy-pjp-references.vue?vue&type=template&id=5e5ea3e5"
import script from "./copy-pjp-references.vue?vue&type=script&lang=js"
export * from "./copy-pjp-references.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports